import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CaretUp = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M7,13.8571429 C7,13.6927075 7.06008124,13.5504098 7.18024554,13.4302455 L11.4302455,9.18024554 C11.5504098,9.06008124 11.6927075,9 11.8571429,9 C12.0215782,9 12.1638759,9.06008124 12.2840402,9.18024554 L16.5340402,13.4302455 C16.6542045,13.5504098 16.7142857,13.6927075 16.7142857,13.8571429 C16.7142857,14.0215782 16.6542045,14.1638759 16.5340402,14.2840402 C16.4138759,14.4042045 16.2715782,14.4642857 16.1071429,14.4642857 L7.60714286,14.4642857 C7.44270751,14.4642857 7.30040983,14.4042045 7.18024554,14.2840402 C7.06008124,14.1638759 7,14.0215782 7,13.8571429 Z"
        />
    </StarryUIIcon>
);
